import {
  DATE_RANGE_NUMERIC_VALUES,
  generateDateMonthsPrevious,
} from './Dashboard.context.helpers';
import { TAction, TDashboardState } from './Dashboard.types';

const generateDateFromDateRange = (dateRange: string | null) => {
  const numberOfMonths = DATE_RANGE_NUMERIC_VALUES[dateRange || 'default'];
  return generateDateMonthsPrevious(numberOfMonths);
};

const reducer = (state: TDashboardState, action: TAction) => {
  switch (action.type) {
    case 'fetchedApplications': {
      return {
        ...state,
        applications: action.applications?.data,
      };
    }
    case 'searchApplication': {
      return {
        ...state,
        searchString: action.searchString,
      };
    }
    case 'searchApplicationDateRange': {
      return {
        ...state,
        dateFrom: generateDateFromDateRange(action.dateFrom),
      };
    }
    case 'searchApplicationPartnerChannelToggle': {
      return {
        ...state,
        includePartnerChannel: action.includePartnerChannel,
      };
    }
    case 'error': {
      return {
        ...state,
        error: action.error,
      };
    }
  }
};

export default reducer;
